import { render, staticRenderFns } from "./ConfirmCancelOrder.vue?vue&type=template&id=350e2d2f&"
import script from "./ConfirmCancelOrder.vue?vue&type=script&lang=js&"
export * from "./ConfirmCancelOrder.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmCancelOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports